/* eslint-disable @typescript-eslint/no-explicit-any */
import { post, get } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';

const definitions = Definitions.TokenEmail;

const callPost = async (params: any): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...params,
    },
  };

  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE[0],
    init,
  );
};

const callGet = async (params: {
  type: string;
  token: string;
}): Promise<IFinalResponse> => {
  const init: InitApiType = {
    params: {
      ...params,
    },
  };
  return get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE[1],
    init,
  );
};

const call = {
  post: callPost,
  get: callGet,
};
export default { call, definitions };
